import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { PageSizeService } from "@shared/services/page-size.service";

@Component({
  selector: 'app-ag-custom-pagination',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownItem,
    NgbDropdownMenu,
  ],
  providers: [{ provide: PageSizeService, useExisting: PageSizeService }],
  templateUrl: 'ag-custom-pagination.component.html',
  styleUrl: 'ag-custom-pagination.component.scss',
})
export class AgCustomPaginationComponent {
  pageSizeService = inject(PageSizeService, { optional: true, skipSelf: true });

  @Input() currentPage = 0;
  @Input() totalPages = 0;
  @Input() paginationPageSize = 0;
  @Input() paginationPageSizeSelector: number[] | undefined;
  @Input() showPageSizeSelector: number[] | boolean = true;
  @Input({ alias: 'pageNumbers' }) set pageNumbersSetter(value: (number | string)[]) {
    this.pageNumbers = value.map((page) => ({ key: Math.random(), page }));
  }

  @Output() previousPage = new EventEmitter<boolean>();
  @Output() nextPage = new EventEmitter<boolean>();
  @Output() selectPage = new EventEmitter<number>();

  readonly defaultPageSize = PageSizeService.defaultPageSize;
  dropdownOpen = false;
  pageNumbers: { key: number, page: (number | string) }[] = [];

  goToPage(page: number): void {
    this.selectPage.emit(page);
  }

  goToPreviousPage(): void {
    this.previousPage.emit(true);
  }

  goToNextPage(): void {
    this.nextPage.emit(true);
  }

  onSelectPageSize(size: number): void {
    this.pageSizeService?.addPageSize(size);
    this.goToPage(0);
  }

  getDropdownState(dropdownState: boolean): void {
    this.dropdownOpen = dropdownState;
  }
}
